import Popup from '../plugins/Popup';
import Form from '../classes/Form';
import { clear } from '../helpers/functions';
import { reCaptchaToken } from '../plugins/ReCaptcha';

function ucwords() {
  this.value = this.value
    .split(' ')
    .map(function(word) {
      return word.substr(0, 1).toUpperCase() + word.substr(1, word.length - 1);
    })
    .join(' ');
}

$(function () {
  var METRIKA;

  if (
    typeof Ya != 'undefined' &&
    typeof ym != 'undefined' &&
    typeof Ya._metrika != 'undefined' &&
    typeof Ya._metrika.getCounters == 'function' &&
    Ya._metrika.getCounters().length > 0 &&
    typeof Ya._metrika.getCounters()[0].id != 'undefined'
  ) {
    METRIKA = Ya._metrika.getCounters()[0].id;
  }

  $('[name=name]').on('input change', ucwords);

  $('select, input, textarea').on('input change', function () {
    if ($(this).hasClass('error')) {
      $(this).removeClass('error');
      $(this).siblings('label.error').remove();
    }
  });

  $('[data-form]').submit(function (e) {
    e.preventDefault();

    const yaGoal = e.target.dataset.ya || null;

    const form = $(this),
      obj = Form.get('#' + $(this).attr('id')),
      submit = form.find('[type="submit"]');

    if (!obj.isValid())
      return false;

    let data = form.serialize();
    let uploadData = {};
    if (form.attr('enctype') === 'multipart/form-data') {
      data = new FormData(form[0]);
      form.find('[type=file]').each(function() {
        for (let i = 0; i < this.files.length; i++)
          data.append($(this).attr('name'), this.files[i]);
      });
      uploadData = {
        processData: false,
        contentType: false
      };
    }

    let goal_fb = $(this).find('.btn').data('goal_fb');
    let goal_gl = $(this).find('.btn').data('goal_gl');

    if (typeof goal_fb != 'undefined') {
      if (goal_fb.length > 0) {
        fbq('track', goal_fb);
      }
    }

    if (typeof goal_gl != 'undefined') {
      if (goal_gl.length > 0) {
        dataLayer.push({'event': goal_gl});
      }
    }

    if (!window.reCaptcha.isDisabled) {
      reCaptchaToken().then(token => {
        if (data instanceof FormData) {
          data.append('recaptcha_token', token);
        } else {
          const searchParams = new URLSearchParams(data);
          if (!searchParams.get('recaptcha_token')) {
            searchParams.set('recaptcha_token', token);
          }

          data = searchParams.toString();
        }
        sendRequest();
      });
    } else {
      sendRequest();
    }

    function sendRequest() {
      $.ajax(Object.assign(uploadData, {
        type: 'POST',
        url: '/ajax/form/send/',
        data: data,

        beforeSend: () => {
          submit.attr('disabled', 'disabled').prop('disabled', true);
          form.parent().find('.popup__close').click();
          Popup.message(null, 'success');
        },

        complete: () => {
          submit.attr('disabled', '').prop('disabled', false);

          if ( typeof ym != 'undefined' && Ya._metrika.getCounters().length > 0) {
            const counter = Ya._metrika.getCounters()[0].id;

            if (yaGoal && window.Ya) {
              window.ym(counter, "reachGoal", yaGoal);
            }

            if (METRIKA == 97037508) {
              window.ym(counter,'reachGoal','allforms');
            }
          }

          clear(form);
        },

        success: () => {}
      }));
    }
  });

  const file = $('[request-file]');
  const fileDelete = $('[file-delete]');

  if (file.length) {
    file.on('change', function () {
      const form = $(this).closest('form');

      if (file.get(0).files.length) {
        const fileName = file.get(0).files[0].name,
          link = form.find('[request-link]'),
          submitGroup = form.find('[form-show]');

        link.attr('data-text', link.text())
            .text(fileName).removeClass('link_dashed')
            .next().show();

        if (submitGroup.length)
          submitGroup.show();
      }
    });

    fileDelete.on('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const form = $(this).closest('form'),
        link = form.find('[request-link]'),
        submitGroup = form.find('[form-show]');

      file.val('');
      link.text(link.attr('data-text')).addClass('link_dashed').next().hide();

      if (submitGroup.length)
        submitGroup.hide();
    });
  }
});
